import {FoodItemImageResponse} from "@/types/service-response";

export default class FoodItemImage {
  private constructor (
    readonly createdAt: string,
    readonly id: string,
    readonly foodItem: string,
    readonly mediaType: string,
    readonly order: number,
    readonly size: number

  ) {}


  static createFromResponse (responseData: FoodItemImageResponse): FoodItemImage {
    return new FoodItemImage(
        responseData.createdAt,
        responseData.id,
        responseData.foodItem,
        responseData.mediaType,
        responseData.order,
        responseData.size,
    )
  }

  static createFromResponseList (responseData: FoodItemImageResponse[]): FoodItemImage[]{
    return  responseData.map((item: FoodItemImageResponse)=>{
      return new FoodItemImage(
          item.createdAt,
          item.id,
          item.foodItem,
          item.mediaType,
          item.order,
          item.size,
      )
        }
    )
  }


}